import Loadable from 'react-loadable';

import { LoadingPageLoadable } from 'modules/main/pages/Loading';

export const LoginPageContainerLoadable = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "LoginPageContainer" */
      './LoginPageContainer.dynamic'
    ),
  loading: LoadingPageLoadable,
});
